import React,  { useState, useEffect } from 'react';
import cn from '../../lib/bem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { showComboValidationCss } from '../../lib/utils/utilitarios';

import './dropdownBank_component.scss';

const DropDownBankComponent = ({label, placeholder, listDropDown, value, accion, msgValidador, focus, activeOther, accionActiveOther}) => {
    
    const classes = cn("dropdownBankComponent");
    const [ combo , mostrarCombo] = useState(false);
    const [ dataLista, setDataLista ] = useState(listDropDown);

    useEffect(()  => {
        setOrderData(dataLista);
    }, [])

    const setOrderData = () => {
        const dataList = [...dataLista].sort((a,b) => {
            return a.descripcion > b.descripcion ? 1 : -1
        });
        setDataLista(dataList);
    }

    const showValueDropdown = () => {
        var nameDropdown = placeholder;
        if( value !== '' ){
            nameDropdown = dataLista.find((element) => element.codigoBanco === value).descripcion;
        }
        return nameDropdown;
    }

    const colorSpanValue = () => {
        var spanColor = 'colorSpanPlah';
        if( value !== '' ){
            spanColor = 'colorSpanValue';
        }
        return spanColor;
    }

    const returnOptionOther = (list, i) => {

        if(activeOther){
            if(list.flagTransferenciaLocal === 'N'){
                return <li data-testid={`${i}_li`} key={i} onClick={() => {mostrarCombo(false); accion( list.codigoBanco )}}>{list.descripcion}</li>;
            }
        } else {
            if(list.flagTransferenciaLocal === 'S'){
                return <li data-testid={`${i}_li`} key={i} onClick={() => {mostrarCombo(false); accion( list.codigoBanco )}}>{list.descripcion}</li>;
            }
        }
    }

    const onCliclActionOther  = () => {
        mostrarCombo(true);
        accion('');
        accionActiveOther();
    }

    const mensajeValidador = msgValidador === '' ? 'dropdownList' : 'dropdownList dropdownList-validador';

    return (
        <div className={classes()}>
            <div className={classes(showComboValidationCss(combo, msgValidador))} onClick={() => { mostrarCombo(!combo); focus() }}>
                <span data-testid={label} className={colorSpanValue()} >{ showValueDropdown() }</span>
                {
                    combo ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />
                }
            </div>
            {
                combo ? <div className={classes(mensajeValidador)}>
                                <ul data-testid={`${label}_ul`} onClick={() => { focus();}}>
                                    {
                                        dataLista.map((list, i) => returnOptionOther(list, i))
                                    }
                                    {
                                        activeOther ?
                                            <li key={1001} onClick={() => {onCliclActionOther()}}>VOLVER A BANCOS PRINCIPALES</li> 
                                        : 
                                            <li key={1000} onClick={() => {onCliclActionOther()}}>OTROS</li>
                                    }
                                </ul>
                            </div> : null
            }
            {
                msgValidador !== '' ? <label className={classes('input-detalle-msgValidador')}>{msgValidador}</label> : null 
            }   
        </div>
    )

}

export default DropDownBankComponent;